<template>
  <el-menu mode="horizontal" @select="handleSelect" router>
    <el-menu-item id="logo" index="/">
      <logo></logo>
    </el-menu-item>
    <el-menu-item index v-if="isManagerOrAdmin()">
      <el-dropdown>
        <span class="el-dropdown-link">
          Administração<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item @click="$router.push(`/admin/books`)"
              >Livros</el-dropdown-item
            >
            <el-dropdown-item @click="$router.push(`/admin/tags`)"
              >Categorias</el-dropdown-item
            >
            <el-dropdown-item
              v-if="isAdmin()"
              @click="$router.push(`/admin/users`)"
              >Usuários</el-dropdown-item
            >
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </el-menu-item>
    <el-menu-item index="/about"> Sobre </el-menu-item>
    <section v-if="!isLogged()">
      <el-menu-item class="dock-right" index="/register">
        Cadastrar
      </el-menu-item>
      <el-menu-item class="dock-right" index="/login"> Entrar </el-menu-item>
    </section>
    <section v-if="isLogged()">
      <el-menu-item class="dock-right">
        <el-dropdown>
          <span>
            <i class="el-icon-setting" style="margin-right: 15px"></i>
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item @click="$router.push(`/user/profile`)"
                >Dados Pessoais</el-dropdown-item
              >
              <el-dropdown-item @click="handleLogout">Logout</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </el-menu-item>
    </section>
  </el-menu>
</template>

<script>
import Logo from "./Logo.vue";
import { getCurrentUser, logOut } from "../services/sessions";

export default {
  components: {
    logo: Logo,
  },
  beforeMount() {
    this.checkLoginStatus();
  },
  methods: {
    profile() {
      this.$router.push(`/user/profile`);
    },
    checkLoginStatus() {
      getCurrentUser()
        .then((response) => {
          if (
            response.data.logged_in == true &&
            this.$store.state.loggedInStatus == "NOT_LOGGED_IN"
          ) {
            this.$store.commit("userStatus", {
              loggedInfo: "LOGGED_IN",
              userData: response.data.user,
            });
          } else if (
            response.data.logged_in == false &&
            this.$store.state.loggedInStatus == "LOGGED_IN"
          ) {
            this.$store.commit("userStatus", {
              loggedInfo: "NOT_LOGGED_IN",
              userData: {},
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.$store.commit("userStatus", {
            loggedInfo: "NOT_LOGGED_IN",
            userData: {},
          });
        });
    },
    handleLogout() {
      logOut()
        .then(() => {
          this.$store.commit("userStatus", {
            loggedInfo: "NOT_LOGGED_IN",
            userData: {},
          });
        })
        .catch((error) => {
          console.log("logout error", error);
        });
      this.$router.push(`/`);
    },
    isManagerOrAdmin() {
      return (
        this.isLogged() &&
        ["admin", "moderator"].includes(this.$store.state.user.user_type)
      );
    },
    isAdmin() {
      return (
        this.isLogged() && ["admin"].includes(this.$store.state.user.user_type)
      );
    },
    isLogged() {
      if (this.$store.state.loggedInStatus == "NOT_LOGGED_IN") {
        return false;
      } else if (this.$store.state.loggedInStatus == "LOGGED_IN") {
        return true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.dock-right {
  float: right;
}
.el-menu > .el-menu-item.dock-right {
  float: right;
}
</style>
